import {DomainObject, oneOf} from 'shared/store';
import {observable, action, computed} from 'mobx';

class EligibilityRecord extends DomainObject {
  @observable state;
  @observable coverageType;
  @observable currentVolume;
  @observable eligibleVolume;
  @observable evidenceMaximum;
  @observable nonEvidenceMaximum;
  @observable annualSalary;

  @action merge(other) {
    super.merge(other, {
      state: oneOf([
        'ineligible',
        'eligible',
        'declined_to_apply',
        'application_approved',
        'application_rejected'
      ])
    });
  }

  @computed get isEligible() {
    return this.state === 'eligible' || this.state === 'declined_to_apply';
  }
}

export default EligibilityRecord;
